/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-08 11:22:33
 * @LastEditors: changfeng
 * @LastEditTime: 2024-05-08 13:43:52
 */
export default {
	"optimizationEvent.SHOPPING": "Complete Payment",
	"optimizationEvent.ADD_BILLING": "Add payment info",
	"optimizationEvent.INITIATE_ORDER": "Initiate Checkout",
	"optimizationEvent.ON_WEB_CART": "Add to Cart",
	"optimizationEvent.ON_WEB_DETAIL": "View Content",
	"optimizationEvent.ON_WEB_ADD_TO_WISHLIST": "Add to wishlist",
	"optimizationEvent.BUTTON": "Click button",
	"optimizationEvent.ON_WEB_REGISTER": "Complete Registration",
	"optimizationEvent.CONTACT": "Contact",
	"optimizationEvent.DOWNLOAD_START": "Download",
	"optimizationEvent.CONSULT": "Consult",
	"optimizationEvent.ON_WEN_ORDER": "Place an Order",
	"optimizationEvent.ON_WEB_SEARCH": "Search",
	"optimizationEvent.FORM": "Submit Form",
	"optimizationEvent.ON_WEB_SUBSCRIBE": "Subscribe"
};
